import {defineStore} from 'pinia'

export const usePaymentBookingStore = defineStore({
    id: 'payment_bookings',
    state: () => ({
        paymentBookings: [],
        itemLength: 0,
        loading: false,
        serverOptions: {
            page: 0,
            rows: 25,
        },
    }),
    getters: {},
    actions: {
        index(params = {}) {
            this.loading = true
            return this.apiClient.get('/payment_bookings', {
                params: {
                    page: this.serverOptions.page + 1,
                    size: this.serverOptions.rows,
                    ...params,
                },
            }).then(({data}) => {
                this.paymentBookings = data.payment_bookings
                this.itemLength = data.itemLength
                this.loading = false
                return data
            }).catch((error) => {
                this.loading = false
                throw error
            })
        },
        update(paymentBookingId, attributes) {
            this.loading = true
            return this.apiClient.patch(`/payment_bookings/${paymentBookingId}`, {
                payment_booking: attributes,
            }).then(({data}) => {
                this.loading = false
                return data.payment_booking || data
            }).catch((error) => {
                this.loading = false
                throw error
            })
        },
        updateRemittanceInformation(paymentBookingId, remittanceInformation) {
            return this.update(paymentBookingId, {remittance_information: remittanceInformation})
        },
    },
})
